import React, { useState, useEffect } from "react";
import {
  Box,
  Divider,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import Breadcrumbs from "../common/breadcrumbs";
import Loading from "../common/loading";
import StateHistoryComponent from "../common/stateHistoryComponent";
import SearchInput from "../common/searchInput";
import DevicesService from "../api/devices";
import ProfileService from "../api/profile";
import NamedLocationsService from "../api/namedLocations";
import AddEditDeviceStateHistory from "./addEditDeviceStateHistory";
import { getUrlVars } from "../utils/systemInfo";
import { setStateHistory } from "../store/stateHistorySlice";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const initialState = {
  device_state_history_id: "",
  serial: "",
  state_type: "Unplanned",
  state_description: "",
  state_result: "",
  state_start: "",
  state_end: "",
  state_location_id: "",
  assigned_to_person_id: "",
  device_state_history_tags: [],
  status: "active",
};
const breadcrumbs = [
  { id: 0, name: "Home", href: "./" },
  { id: 1, name: "DeviceStateHistory", href: "deviceStateHistory" },
];
const StyledButton = styled((props) => <Button {...props} />)(({ theme }) => ({
  height: "36px",
  backgroundColor: theme.palette.custom.buttonColor,
  color: theme.palette.custom.buttonTextColor,
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
  float: "right",
  width: "min-content",
  whiteSpace: "nowrap",
  padding: "1rem",
}));

function DeviceStateHistoryPage() {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const [drawerState, setDrawerState] = useState(false);
  const [loadingValue, setLoadingValue] = useState(true);
  const [deviceStateHistoryList, setDeviceStateHistoryList] = useState([]);
  const organziation = useSelector(({ organziation }) => organziation);

  const [usersList, setUsersList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [tagsList, setTags] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const deviceSerial = String(getUrlVars()["serial"]);

  const isGlobalView = deviceSerial === "undefined";

  const sortOptions = [
    { value: "state_type", label: "State Type" },
    { value: "assigned_user", label: "Assigned User" },
    { value: "start_time", label: "Start Time" },
    { value: "location", label: "Location" },
    { value: "tags", label: "Tags" },
    ...(isGlobalView
      ? [
          { value: "machine_name", label: "Machine Name" },
          { value: "machine_type", label: "Machine Type" },
          { value: "oem", label: "OEM" },
        ]
      : []),
  ];

  useEffect(() => {
    getDeviceStateHistory();
    const orgObj = JSON.parse(localStorage.getItem("defaultOrganization"));
    const apiKey =
      organziation?.api_key_list?.[0]?.key ?? orgObj?.api_key_list?.[0]?.key;
    const orgOperationId = organziation?.operation_id ?? orgObj?.operation_id;

    ProfileService.GetUserProfile({
      profile_uid: "",
      profile_id: "",
      app_profile_uid: "",
      firstname: "",
      lastname: "",
      tel_primary: "",
      email_primary: "",
      status: "active",
      apiKey: apiKey,
    })
      .then((json) => {
        if (json && json.person_profile && json.person_profile.length > 0) {
          setUsersList(json?.person_profile);
        }
      })
      .catch(() => {});
    NamedLocationsService.GetNamedLocations({
      // id: id,
      apiKey,
    })
      .then((jsonCurrent) => {
        if (jsonCurrent?.config_operation_location_named_lookup?.length) {
          setLocationsList(jsonCurrent?.config_operation_location_named_lookup);
        }
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
    DevicesService.GetOrgnizationTags({
      device_state_tag_id: "",
      operation_id: orgOperationId,
      dst: {
        f: "",
        t: "",
      },
      apiKey,
    })
      .then((jsonCurrent) => {
        if (jsonCurrent?.device_state_tag?.length) {
          const tagsArray = [];
          for (
            let index = 0;
            index < jsonCurrent?.device_state_tag?.length;
            index++
          ) {
            tagsArray.push({
              id: jsonCurrent?.device_state_tag[index].device_state_tag_id,
              name: jsonCurrent?.device_state_tag[index].tag_name,
            });
          }
          setTags(tagsArray);
        }
        setLoadingValue(false);
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function getDeviceStateHistory() {
    console.log("getDeviceStateHistory called from refresh");
    console.log("getTags");
    const apiKey =
      organziation?.api_key_list?.[0]?.key ?? localStorage.getItem("apiKey");

    DevicesService.GetStateHistoryPerDevice({
      // device_state_history_id: "",
      serial: deviceSerial,
      dst: {
        f: "",
        t: "",
      },
      apiKey,
    })
      .then((jsonCurrent) => {
        if (jsonCurrent?.device_state_history?.length > 0) {
          console.log(
            "setDeviceStateHistoryList",
            jsonCurrent?.device_state_history
          );
          setDeviceStateHistoryList(jsonCurrent?.device_state_history);
          setLoadingValue(false);
        } else {
          setDeviceStateHistoryList([]);
        }
        setLoadingValue(false);
      })
      .catch((errorr) => {
        if (process.env.NODE_ENV === "development")
          console.log("getUserTypePermissionserrorr", errorr);
      });
  }

  const handleAddNewState = () => {
    dispatch(setStateHistory(initialState));
    setDrawerState(true);
    //  handleNavigate(event, navigate, "/addEditNamedLocation");
  };

  function handleSearch(ev) {
    const newSearchText = ev.target.value;
    setSearchText(newSearchText);
  }
  function toggleDrawer(open) {
    setDrawerState(open);
  }

  const search = searchText.toLowerCase();
  const filteredStateHistoryList = deviceStateHistoryList.filter((item) => {
    if (deviceSerial === "undefined") {
      const assignedUser = usersList.find(
        (user) => user.profile_uid?.toString() === item.assigned_to_person_id
      );
      const assignedUserName = assignedUser
        ? `${assignedUser.firstname} ${assignedUser.lastname}`.toLowerCase()
        : "";

      const location = locationsList.find(
        (loc) =>
          loc.operation_location_named_lookup_id === item.state_location_id
      );
      const locationName = location?.name?.toLowerCase() ?? "";

      const formattedStartTime = item.state_start?.toLowerCase() ?? "";

      const tagNames = (item.device_state_history_tags || [])
        .map((tag) => tag.tag_name?.toLowerCase())
        .join(" ");

      const machineName = item.device_profile?.name?.toLowerCase() ?? "";
      const machineType =
        item.device_profile?.machine_type?.toLowerCase() ?? "";
      const oem = item.device_profile?.oem?.toLowerCase() ?? "";

      return (
        item.state_type?.toLowerCase()?.includes(search) ||
        assignedUserName?.includes(search) ||
        formattedStartTime?.includes(search) ||
        locationName?.includes(search) ||
        tagNames?.includes(search) ||
        machineName?.includes(search) ||
        machineType?.includes(search) ||
        oem?.includes(search)
      );
    } else {
      const assignedUser = usersList.find(
        (user) => user.profile_uid?.toString() === item.assigned_to_person_id
      );
      const assignedUserName = assignedUser
        ? `${assignedUser.firstname} ${assignedUser.lastname}`.toLowerCase()
        : "";
      const location = locationsList.find(
        (loc) =>
          loc.operation_location_named_lookup_id === item.state_location_id
      );
      const locationName = location?.name?.toLowerCase() ?? "";
      const formattedStartTime = item.state_start?.toLowerCase() ?? "";
      const tagNames = (item.device_state_history_tags || [])
        .map((tag) => tag.tag_name?.toLowerCase())
        .join(" ");
      return (
        item.state_type?.toLowerCase()?.includes(search) ||
        assignedUserName?.includes(search) ||
        formattedStartTime?.includes(search) ||
        locationName?.includes(search) ||
        tagNames?.includes(search)
      );
    }
  });

  const sortedStateHistoryList = [...filteredStateHistoryList].sort((a, b) => {
    const getAssignedName = (item) => {
      const u = usersList.find(
        (user) => user.profile_uid?.toString() === item.assigned_to_person_id
      );
      return u ? `${u.firstname} ${u.lastname}`.toLowerCase() : "";
    };

    const getLocationName = (item) => {
      const l = locationsList.find(
        (loc) =>
          loc.operation_location_named_lookup_id === item.state_location_id
      );
      return l?.name?.toLowerCase() ?? "";
    };

    const getTagString = (item) =>
      (item.device_state_history_tags || [])
        .map((tag) => tag.tag_name?.toLowerCase())
        .join(" ");

    const getSortValue = (item) => {
      switch (sortBy) {
        case "state_type":
          return item.state_type?.toLowerCase() ?? "";
        case "assigned_user":
          return getAssignedName(item);
        case "start_time":
          return item.state_start ?? "";
        case "location":
          return getLocationName(item);
        case "tags":
          return getTagString(item);
        case "machine_name":
          return item.device_profile?.name?.toLowerCase() ?? "";
        case "machine_type":
          return item.device_profile?.machine_type?.toLowerCase() ?? "";
        case "oem":
          return item.device_profile?.oem?.toLowerCase() ?? "";
        default:
          return "";
      }
    };

    const aVal = getSortValue(a);
    const bVal = getSortValue(b);

    return sortDirection === "asc"
      ? aVal.localeCompare(bVal)
      : bVal.localeCompare(aVal);
  });

  return (
    <Box
      sx={{
        p: "12px",
        minHeight: `100%`,
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: { xs: "block", sm: "center" },
          height: "64px",
        }}
      >
        <Box sx={{ display: { xs: "block", sm: "flex" } }}>
          <Box sx={{ width: "100%" }}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Typography
              sx={{
                fontSize: "35px",
                mb: 0,
                color: theme.palette.custom.text,
              }}
              variant="h2"
              gutterBottom
            >
              {t("DeviceStateHistory")}
            </Typography>
          </Box>
        </Box>
        <StyledButton variant="contained" onClick={handleAddNewState}>
          {t("AddNewState")}
        </StyledButton>
      </Box>
      <Divider
        sx={{ mb: "10px", backgroundColor: theme.palette.custom.borderColor }}
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 2,
          justifyContent: "space-between",
        }}
      >
        <SearchInput
          searchText={searchText}
          handleSearch={handleSearch}
          autoFocus
          sx={{
            width: { xs: "100%", sm: "40%" },
            borderColor: theme.palette.custom.borderColor,
            borderRadius: "11px",
            backgroundColor: theme.palette.custom.light,
          }}
        />
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControl size="small" sx={{ minWidth: 200, mr: "5px" }}>
            <InputLabel id="sort-by-label">Sort By</InputLabel>
            <Select
              labelId="sort-by-label"
              value={sortBy}
              label="Sort By"
              onChange={(e) => setSortBy(e.target.value)}
            >
              <MenuItem value="">None</MenuItem>
              {sortOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            size="small"
            sx={{ p: 0, minWidth: 0 }}
            onClick={() =>
              setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"))
            }
          >
            {sortDirection === "asc" ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </Button>
        </Box>
      </Box>
      {loadingValue ? (
        <Box sx={{ height: "30vh", pt: "10%" }}>
          <Loading />
        </Box>
      ) : (
        sortedStateHistoryList &&
        sortedStateHistoryList.map((row, index) => (
          <>
            <StateHistoryComponent
              key={index}
              usersList={usersList}
              locationsList={locationsList}
              row={row}
              triggerToggleDrawer={toggleDrawer}
            />

            <Divider
              sx={{
                mb: "10px",
                backgroundColor: theme.palette.custom.borderColor,
              }}
            />
          </>
        ))
      )}

      {/* //   <StateHistoryComponent
    //     row={{
    //       type: "broken",
    //       tags: [
    //         { name: "nerohub", color: "red" },
    //         { name: "rfsasd", color: "green" },
    //       ],
    //       description: "we need to do this because it's important",
    //       assignedTo: "Amr Essam",
    //       location: "Salt District Base",
    //     }}
    //   />

    //   <Divider
    //     sx={{ mb: "10px", backgroundColor: theme.palette.custom.borderColor }}
    //   />
    //   <StateHistoryComponent
    //     row={{
    //       type: "done",
    //       tags: [
    //         { name: "nerohub", color: "blue" },
    //         { name: "rfsasd", color: "green" },
    //       ],
    //       description: "we need to do this because it's important",
    //       assignedTo: "Ali Ezz",
    //       location: "Salt District Base",
    //       device_profile: {
    //         device_profile_id: "20201111131601215_KLQHrUeHAg4h43Mmy",
    //         device_uid: 8,
    //         name: "MK36",
    //         device_type: "nerohub",
    //         device_type_id: "20210222115215106_pDAESG8J81sw7XioG",
    //         serial: "262213",
    //         device_oem_operation_profile_uid: "",
    //         machine_type: "MK35",
    //         source: "",
    //         latest_data_dst_s: "2024-11-13",
    //         dst: "2025-03-10 05:29:59.197",
    //         description: "",
    //         log_type: "1",
    //         vehicle_type: "Dump Truck",
    //         oem: "GHH",
    //         dst_last_seen: "2024-11-13 10:48:12 AM",
    //         dst_last_opsum: "2024-11-13 10:00:00 AM",
    //         dst_last_raw: "2025-01-08 3:35:48 PM",
    //         manufacturer_sn: "",
    //         mac_address: "",
    //         status: "",
    //       },
    //     }}
    //   />
    //   <Divider
    //     sx={{ mb: "10px", backgroundColor: theme.palette.custom.borderColor }}
    //   /> */}
      <SwipeableDrawer
        PaperProps={{
          sx: {
            color: theme.palette.custom.text,
            display: { xs: "none", sm: "block" },
          },
        }}
        sx={{
          "& .MuiDrawer-paper": {
            pt: "64px",
            px: "10px",
            boxSizing: "border-box",
            width: { xs: "100%", sm: "50%" },
            color: theme.palette.custom.text,
          },
        }}
        anchor={"right"}
        open={drawerState}
        onClose={() => toggleDrawer(false)}
        onOpen={() => toggleDrawer(true)}
      >
        <AddEditDeviceStateHistory
          usersList={usersList}
          locationsList={locationsList}
          triggerToggleDrawer={toggleDrawer}
          refreshStateHistory={getDeviceStateHistory}
          tagsList={tagsList}
        />
      </SwipeableDrawer>
    </Box>
  );
}

export default DeviceStateHistoryPage;
